import { ClipboardDocumentIcon } from '@heroicons/react/24/outline'
import { toast } from '@/store/toastStore'

interface GcpCopyButtonProps {
  text: string
  label?: string
  className?: string
}

export default function GcpCopyButton({ text, label = 'Copy', className = '' }: GcpCopyButtonProps) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      toast.success('Copied to clipboard')
    } catch {
      toast.error('Failed to copy to clipboard')
    }
  }

  return (
    <button
      type="button"
      onClick={() => void handleCopy()}
      className={`inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 ${className}`}
      title={label}
    >
      <ClipboardDocumentIcon className="h-3.5 w-3.5" aria-hidden />
      {label}
    </button>
  )
}
